import React, {useState} from "react";
import ImgixFilePreview from "../../newComponents/ImgixFilePreview";
import { CgSoftwareDownload } from "react-icons/cg";

const Brochure = ({ block }) => 
{
    const [loaded, setLoaded] = useState(0);

    return (
        <section>
            <div className="shell flex flex-wrap">
                {block.BrochureLink &&
                    <div className="flex-none w-1/2 mb-6">
                        <figure>
                            <iframe title="Brochure" style={{"border":"1px solid #777"}} src={block.BrochureLink} width="100%" height="100%" frameBorder={0} allowFullScreen />
                        </figure>
                    </div>
                }
                {block.brochure.map((brochure, index) => (
                    <div key={index} className="flex-none w-1/2 mb-6 pr-6">
                        <div className="relative border-gray-300 border-solid border aspect-[16/9]">
                            <a href={brochure.url} target="_blank" rel="noreferrer">
                                {loaded >= index &&
                                    <ImgixFilePreview onLoad={() => {setLoaded(index + 1)}} fileUrl={brochure.url} className="aspect-[16/9]" />
                                }
                                <span className="absolute  top-0 left-0 w-full h-full flex justify-center items-center">
                                    <CgSoftwareDownload className="w-12 h-12 text-white" style={{filter: "drop-shadow( 3px 3px 5px rgba(0, 0, 0, .9))"}} alt=""/>
                                </span>
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default Brochure;
